"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var dx_react_grid_material_ui_1 = require("@devexpress/dx-react-grid-material-ui");
var collectionsRef_1 = require("common/db/collectionsRef");
var projectsList_1 = require("common/global/projectsList");
var usersList_1 = require("common/global/usersList");
var firebase_1 = __importDefault(require("firebase"));
var hasProjectPermission_1 = require("portal/pages/Projects/hasProjectPermission");
var defaultDevExtremeGridComponents_1 = __importDefault(require("portal/utils/defaultDevExtremeGridComponents"));
var react_1 = __importDefault(require("react"));
var firestore_1 = require("react-firebase-hooks/firestore");
var react_i18next_1 = require("react-i18next");
var react_router_dom_1 = require("react-router-dom");
var useTitle_1 = __importDefault(require("../../../hooks/useTitle"));
function IRsApprovedByMe() {
    var _a, _b;
    var t = (0, react_i18next_1.useTranslation)().t;
    (0, useTitle_1.default)(t('common.IR'));
    var userId = (_a = firebase_1.default.auth().currentUser) === null || _a === void 0 ? void 0 : _a.uid;
    var approvals = (0, firestore_1.useCollection)(collectionsRef_1.approvalsRef.where('formType', '==', 'internal-request').where('userId', '==', userId))[0];
    var approvalsData = approvals === null || approvals === void 0 ? void 0 : approvals.docs.map(function (e) {
        var data = e.data();
        return data === null || data === void 0 ? void 0 : data.formId;
    });
    var docId = approvalsData[0];
    var ref = (0, firestore_1.useDocument)(collectionsRef_1.IRsRef.doc((_b = approvalsData[0]) !== null && _b !== void 0 ? _b : 'dsf'))[0];
    var data = ref.data();
    // const [snapshot] = useCollection(ref)
    // const dataSource = (snapshot?.docs ?? []).map(s => {
    //     const data = s.data() as IR
    //     return {
    //         ...data,
    //         id: s.id,
    //     }
    // })
    var columns = [
        {
            name: 'projectId',
            title: t('projects.projectName'),
            getCellValue: function (r) {
                var _a;
                return (_a = projectsList_1.globalProjectsData[r.projectId]) === null || _a === void 0 ? void 0 : _a.name;
            },
        },
        {
            name: 'createdAt',
            title: t('orders.createdAt'),
            getCellValue: function (r) {
                var _a;
                return t('common.fullDateTime', { date: (_a = r.createdAt) === null || _a === void 0 ? void 0 : _a.toDate() });
            },
        },
        {
            name: 'requestedAt',
            title: t('orders.requestedAt'),
            getCellValue: function (r) {
                var _a;
                return t('common.fullDateTime', { date: (_a = r.requestedAt) === null || _a === void 0 ? void 0 : _a.toDate() });
            },
        },
        {
            name: 'requestedBy',
            title: t('orders.requestedBy'),
            getCellValue: function (r) {
                var _a, _b;
                return (_b = (_a = usersList_1.globalUsersData[r.requestedBy]) === null || _a === void 0 ? void 0 : _a.name) !== null && _b !== void 0 ? _b : '';
            },
        },
        {
            name: 'initiatedBy',
            title: t('orders.initiatedBy'),
            getCellValue: function (r) {
                var _a, _b;
                return (_b = (_a = usersList_1.globalUsersData[r.initiatedBy]) === null || _a === void 0 ? void 0 : _a.name) !== null && _b !== void 0 ? _b : '';
            },
        },
        {
            name: 'status',
            title: t('orders.status'),
        },
        {
            name: 'id',
            title: t('common.actions'),
            key: 'id',
            filteringEnabled: false,
            getCellValue: function Actions(row) {
                var projectId = data.find(function (e) { return e.id === row.id; }).projectId;
                return ((0, jsx_runtime_1.jsx)("div", { children: (0, hasProjectPermission_1.hasProjectPermission)(projectId, ['IRView']) ? ((0, jsx_runtime_1.jsx)("span", __assign({ style: {} }, { children: (0, jsx_runtime_1.jsx)(react_router_dom_1.Link, __assign({ to: "/internal-requests/".concat(row.id, "/"), type: "primary", style: { margin: '0px 5px' } }, { children: t('common.view') })) }))) : null }));
            },
        },
    ];
    return ((0, jsx_runtime_1.jsx)("div", { children: (0, jsx_runtime_1.jsxs)(dx_react_grid_material_ui_1.Grid, __assign({ rows: [data], columns: columns }, { children: __spreadArray([], (0, defaultDevExtremeGridComponents_1.default)({
                table: 'internal-requests',
                allowHidingColumns: false,
            }), true) })) }));
}
exports.default = IRsApprovedByMe;
